import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

function GoogleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853" />
            <path d="M3.964 10.707A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05" />
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.961L3.964 6.293C4.672 4.166 6.656 3.58 9 3.58z" fill="#EA4335" />
        </svg>
    );
}

export default function Login() {
    const handleLogin = async () => {
        try {
            await signInWithPopup(auth, googleProvider);
        } catch (e) {
            console.error('로그인 실패:', e);
        }
    };

    return (
        <div className="login-screen">
            <div className="login-card">
                <div className="login-logo">✦</div>
                <div className="login-title">나의 운동 일지</div>
                <div className="login-sub">기록하고, 성장하고, 반복하라.</div>
                <button className="google-btn" onClick={handleLogin}>
                    <GoogleIcon />
                    Google로 시작하기
                </button>
                <p className="login-terms">
                    로그인을 하면{' '}
                    <a
                        href="https://healthy-sail-1cd.notion.site/34fee71053db804199bad241ccd34d65?source=copy_link"
                        target="_blank"
                        rel="noreferrer"
                    >
                        개인정보 수집 및 이용약관
                    </a>
                    에 동의하는 것으로 간주됩니다.
                </p>
            </div>
        </div>
    );
}
